import { render, staticRenderFns } from "./chunai_gdca.vue?vue&type=template&id=4fac70f0&scoped=true"
import script from "./chunai_gdca.vue?vue&type=script&lang=js"
export * from "./chunai_gdca.vue?vue&type=script&lang=js"
import style0 from "./chunai_gdca.vue?vue&type=style&index=0&id=4fac70f0&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac70f0",
  null
  
)

export default component.exports